import { createFileRoute, Outlet } from '@tanstack/react-router';
import { OrganizerShell } from '@/app/shell/OrganizerShell';
import { myOrganizationsQuery } from '@/features/organizer/api';

export const Route = createFileRoute('/_authed/org/$organizationId')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(myOrganizationsQuery());
  },
  component: OrganizationWorkspace,
});

function OrganizationWorkspace() {
  const { organizationId } = Route.useParams();
  return (
    <OrganizerShell organizationId={organizationId}>
      <Outlet />
    </OrganizerShell>
  );
}
